import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import logo from '../logo.png';
import weixinImg from '../asset/weixin_qrcode.jpg';
import qqImg from '../asset/qq_qrcode.png';
import { LinkContainer } from 'react-router-bootstrap'
export default function YumNavbar () {
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand href="#">
          <img src={logo} alt="logo" width={24}/>
          <span> Stable Diffusion 中文网</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
         <Nav className="me-auto">
          <LinkContainer to="/"><Nav.Link>免费资源</Nav.Link></LinkContainer>
          <LinkContainer to="/taste"><Nav.Link>在线体验</Nav.Link></LinkContainer>
          <LinkContainer to="/magichub"><Nav.Link>咒语宝典</Nav.Link></LinkContainer>
         </Nav>
         <Nav>
          <OverlayTrigger
            trigger={["click"]}
            placement="bottom"
            overlay={
              <Popover>
                <Popover.Header as="h3">{`欢迎入群，一起交流AI创作技巧`}</Popover.Header>
                <Popover.Body>
                  <p><img alt="qq群二维码：705791701" src={qqImg} width={220}/></p>
                  <p><a target="_blank" rel="noreferrer" href="https://qm.qq.com/cgi-bin/qm/qr?k=FIz8CmkavOB5GYwoR8xjBVJ95WJalQXJ&jump_from=webapi&authKey=+zj6q+B3kNrZWCMFoxi8W56mKAg5uvvxWe8JPe6YVRKXPIU3cKd37mkbQVH5x+Se">qq群：705791701</a></p> 
                  <p>微信群主：digitalphysics</p>
                  <p><img  alt="wx号：digitalphysics" src={weixinImg} width={220}/></p>
                  <p>(加微信时，请注明加AI绘画交流群)</p>
                </Popover.Body>
              </Popover>
            }
          >
            <Button variant="primary">qq/微信群</Button>
          </OverlayTrigger>
         </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}